



















































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import AlterationI18nMixin from "@/modules/budget/alteration/mixins/alteration-i18n-mixin";

type SortDirection = 'asc' | 'desc';
type SortableField = 'expense_code' | 'nameRu' | 'nameKz';

// Названия полей плана по месяцам
const PLAN_MONTHS = ['january', 'february', 'march', 'april', 'may', 'june',
    'july', 'august', 'september', 'october', 'november', 'december'];

interface TableRow {
    id: string;
    index: number;
    expense_code: string;
    check: boolean;
    locked: boolean;
    nameRu: string;
    nameKz: string;
    prg: number;
    ppr: number;
    [key: string]: any; // Add index signature to allow string-based access
}

interface BudgetItem {
    gu: string;
    abp: string;
    prg: number;
    ppr: number;
    spf: string;
    leftMonth: number;
    expense_code?: string;
    expense_name_ru?: string;
    expense_name_kz?: string;
    utochSum?: number;
    collapse?: boolean;
    visible?: boolean;
    new?: boolean;
    selectedRow?: boolean;
    [key: string]: any;
}

@Component({
    name: 'c-transf-add-modal',
    mixins: [AlterationI18nMixin]
})
export default class CTransfAddItemModal extends AlterationI18nMixin {
    @Prop({ required: true, default: false }) private show!: boolean;
    @Prop({ required: false, default: () => [] }) private tableData!: TableRow[];
    @Prop({ required: true, default: () => ({} as BudgetItem) }) private itemsEl!: BudgetItem;

    private showModal = false;
    private sortField: SortableField = 'expense_code';
    private sortDirection: SortDirection = 'asc';
    private selectedRows: Set<string> = new Set();

    get locale(): string {
        return this.$i18n.locale.charAt(0).toUpperCase() + this.$i18n.locale.slice(1);
    }

    get sortableTableData(): TableRow[] {
        return this.tableData.sort(this.sortByField(this.sortField, this.sortDirection));
    }

    @Watch('show')
    onShowChanged(newVal: boolean) {
        if (newVal) {
            this.showModal = true;
        }
    }

    private onChecked(row: any, checked: boolean) {
        this.tableData.forEach(tRow => {
            if (tRow.index === row.index) {
                tRow.check = checked;
            }
        });
        row.check = checked;
    }

    private setName(row: TableRow) {
        return row[`name${this.locale}`] as string;
    }

    private onAddItems(): void {
        const selectedItems = this.tableData.filter(item => item.check && !item.locked);
        if (!selectedItems.length) return;
        // Берём только нужные поля из itemsEl, чтобы не тянуть лишние данные
        const { abp, gu, prg, ppr, spf, leftMonth, plan_type } = JSON.parse(JSON.stringify(this.itemsEl));
        const baseFields = { abp, gu, prg, ppr, spf, leftMonth, plan_type };

        const newItems = selectedItems.map(item => {
            const newItem: BudgetItem = {
                ...baseFields,
                expense_code: item.expense_code,
                expense_name_ru: item.nameRu,
                expense_name_kz: item.nameKz,
                utochSum: 0,
                collapse: true,
                visible: true,
                new: true,
                selectedRow: false,
                // Собственный объект ошибок ФЛК, а не общий с родителем по ссылке
                flk: {},
                // Остаток родителя (специфики) проекту не принадлежит
                ost: 0,
                ostDate: null,
                // Агрегаты специфики (сумма, план) проекту не наследуются
                sum: 0,
                plan: 0,
                ...this.addMonthFields(),
                // План специфики проекту не наследуется - реальные плановые значения проставит
                // newAlterationForm.assignProjectPlan на основе плана по этому же проекту (если он есть)
                ...this.addPlanMonthFields()
            };
            return newItem;
        });

        this.$emit('addItemClk', {
            parent: JSON.parse(JSON.stringify(this.itemsEl)),
            newChildren: newItems,   // только новые, без старых
            types: this.itemsEl.plan_type
        });

        this.showModal = false;
    }

    private addMonthFields(): { [key: string]: number } {
        const months: { [key: string]: number } = {};
        for (let i = 0; i < 12; i++) {
            months[`month${i}`] = 0;
            months[`month_${i}`] = 0;
        }
        return months;
    }

    // Обнуляет плановые месяцы (january..december), унаследованные от специфики через spread this.itemsEl -
    // реальный план по проекту проставит newAlterationForm.assignProjectPlan
    private addPlanMonthFields(): { [key: string]: number } {
        const planMonths: { [key: string]: number } = {};
        for (const month of PLAN_MONTHS) {
            planMonths[month] = 0;
        }
        return planMonths;
    }

    private sortCode(field: SortableField) {
        if (this.sortField === field) {
            this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
        } else {
            this.sortField = field;
            this.sortDirection = 'desc';
        }
        this.sortTable();
    }

    private sortTable() {
    [...this.tableData].sort(this.sortByField(this.sortField, this.sortDirection));
    }

    private sortByField(field: string, direction: SortDirection) {
        return (a: TableRow, b: TableRow) => {
            const valueA = (a[field] as string | undefined)?.toString() || '';
            const valueB = (b[field] as string | undefined)?.toString() || '';
            return direction === 'asc'
                ? valueA.localeCompare(valueB)
                : valueB.localeCompare(valueA);
        };
    }
}
